'use client';
import { GoArrowLeft } from 'react-icons/go';
import Select from 'react-select';
import { industries } from 'lib/theraStartConstants';

export default function IndustryStep({ formik, onBack }) {
  return (
    <>
      {/* Back Button */}
      <button
        type="button"
        onClick={onBack}
        className="mb-[0.5rem] flex cursor-pointer items-center gap-[0.5rem] text-[1rem] font-bold text-dark transition-colors hover:text-blue-600 focus:outline-none"
      >
        <GoArrowLeft size={18} />
        <span className="text-base font-semibold">Back</span>
      </button>

      <h2 className="mb-[0.5rem] text-[1.65rem] font-[500] leading-tight text-[#191919]">
        What Kind Of Business Are You Forming?
      </h2>
      <p className="mb-[0.8rem] text-base font-[400] text-light-gray">
        Now, pick a category for your business. For example: landscaping, food truck, etc. If you don't see your
        industry, try another keyword or skip this step.
      </p>

      {/* Industry Selection */}
      <div className="mb-[0.5rem]">
        <label htmlFor="industry" className="mb-[0.5rem] block text-[1rem] font-[500] text-black">
          Select Industry
        </label>
        <Select
          id="industry"
          name="industry"
          components={{
            IndicatorSeparator: () => null,
          }}
          options={industries}
          menuShouldScrollIntoView={false}
          classNamePrefix="react-select"
          className="no-focus-ring mb-[0.5rem] text-[#11111180]"
          value={industries.find((option) => option.value === formik.values.industry) || null}
          onChange={(option) => formik.setFieldValue('industry', option?.value || '')}
          onBlur={() => formik.setFieldTouched('industry', true)}
          placeholder="Select Industry"
          isSearchable={true}
          styles={{
            control: (base, industry) => ({
              ...base,
              width: '100%',
              padding: '0.125rem',
              fontSize: '1rem',
              borderRadius: '0.5rem',
              backgroundColor: 'var(--card)',
              borderColor: formik.touched.industry && formik.errors.industry ? '#f56565' : 'var(--border)',
              boxShadow: industry.isFocused ? '0 0 0 2px rgba(59, 130, 246, 0.5)' : 'none',
              '&:hover': {
                borderColor: formik.touched.industry && formik.errors.industry ? '#f56565' : '#a0aec0',
              },
            }),
            placeholder: (base) => ({
              ...base,
              color: 'var(--muted-foreground)',
            }),
            singleValue: (base) => ({
              ...base,
              color: 'var(--foreground)',
            }),
            input: (base) => ({
              ...base,
              color: 'var(--foreground)',
            }),
            menu: (base) => ({
              ...base,
              maxHeight: '12.5rem',
              backgroundColor: 'var(--popover)',
            }),
            menuList: (base) => ({
              ...base,
              maxHeight: '12.5rem',
            }),
            option: (base, optionState) => ({
              ...base,
              backgroundColor: optionState.isSelected
                ? '#2684FF'
                : optionState.isFocused
                  ? 'var(--accent)'
                  : 'var(--popover)',
              color: optionState.isSelected ? '#ffffff' : 'var(--foreground)',
            }),
          }}
        />
        {formik.touched.industry && formik.errors.industry && (
          <div className="mt-1 text-sm text-red-500">{formik.errors.industry}</div>
        )}
      </div>
    </>
  );
}
